module.exports = __webpack_public_path__ + "static/media/gauri_kale.50a60aeb.png";